import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  SteamBoilersSection,
  SteamDailySection,
  SteamDowntimeSection,
  SteamMonthHeadline,
  SteamPlantReport,
  SteamSection,
  SteamSummarySection,
  SteamTab,
} from './steam.models';

export interface SteamPlantInfo {
  id: number;
  name: string;
  superintendent?: string | null;
  heatedCubageFt3?: number | null;
  heatedGsfFt2?: number | null;
  boilerCount: number;
}

export interface SteamOverview {
  plant: SteamPlantInfo;
  months: SteamMonthHeadline[];
}

const STEAM_URL = `${environment.apiBaseUrl}/steam`;

@Injectable({ providedIn: 'root' })
export class SteamApiService {
  constructor(private http: HttpClient) {}

  getOverview(): Observable<SteamOverview> {
    return this.http.get<SteamOverview>(STEAM_URL);
  }

  getReport(billingMonth: string): Observable<SteamPlantReport | null> {
    return this.http.get<SteamPlantReport>(`${STEAM_URL}/reports/${billingMonth}`).pipe(catchError(() => of(null)));
  }

  getSummary(billingMonth: string): Observable<SteamSummarySection | null> {
    return this.http.get<SteamSummarySection>(`${STEAM_URL}/reports/${billingMonth}/summary`).pipe(catchError(() => of(null)));
  }

  getDaily(billingMonth: string): Observable<SteamDailySection | null> {
    return this.http.get<SteamDailySection>(`${STEAM_URL}/reports/${billingMonth}/daily`).pipe(catchError(() => of(null)));
  }

  getBoilers(billingMonth: string): Observable<SteamBoilersSection | null> {
    return this.http.get<SteamBoilersSection>(`${STEAM_URL}/reports/${billingMonth}/boilers`).pipe(catchError(() => of(null)));
  }

  getDowntime(billingMonth: string): Observable<SteamDowntimeSection | null> {
    return this.http.get<SteamDowntimeSection>(`${STEAM_URL}/reports/${billingMonth}/downtime`).pipe(catchError(() => of(null)));
  }

  getSection(billingMonth: string, tab: SteamTab): Observable<SteamSection | null> {
    if (tab === 'summary') return this.getSummary(billingMonth);
    if (tab === 'daily') return this.getDaily(billingMonth);
    if (tab === 'boilers') return this.getBoilers(billingMonth);
    return this.getDowntime(billingMonth);
  }
}
